const { createSelector } = require('reselect');

export const selectApplications = createSelector(
	state => state.main,
	main => main.applications
);
